import type { NewPendingMessage } from "@/components/ai/chat/ChatInput";
import type { PendingMessage } from "@/hooks/use-stream-conversation";
import { useState } from "react";

export const usePendingMessages = () => {
    const [pendingMessages, setPendingMessages] = useState<PendingMessage[]>([]);

    const handleNewMessage = (message: NewPendingMessage, countOfUserBlocks: number) => {
        if (!message.content) {
            // If content is undefined, it means the message with `id` failed to be sent
            // and should be retracted again.
            setPendingMessages((prev) => prev.filter((m) => m.id !== message.id));
            return;
        }

        // Filter out any pending messages that have already been retained in the conversation. This mostly
        // so that the pending messages don't grow indefinitely.
        const filtered = pendingMessages.filter((m) => m.expectedUserBlockNumber > countOfUserBlocks);
        const msg = {
            id: message.id,
            content: message.content,
            expectedUserBlockNumber: countOfUserBlocks + filtered.length + 1,
        } satisfies PendingMessage;
        setPendingMessages([...filtered, msg]);
    };

    return { pendingMessages, setPendingMessages, handleNewMessage };
};
